const events_br = require('./events.json')
export default events_br